import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';

// Have to import this way to get the fr-ca locale, apparently
const moment = require('moment');
require('moment/locale/fr-ca');

Vue.config.productionTip = false;
Vue.use(VueI18n);

if (process.env.VUE_APP_RESORT.match(/tremblant-fr|tremblant-summer-fr/)) {
  Vue.use(require('vue-moment'), { moment });
}

const resortSlug = process.env.VUE_APP_RESORT;
const { embedEnvironment } = document.getElementById('app').dataset;
const locale = resortSlug.match(/tremblant-fr|tremblant-summer-fr/)
  ? 'fr-ca'
  : 'en';
const i18n = new VueI18n({
  locale,
  silentTranslationWarn: true,
});

store.commit('SET_EMBED_ENVIRONMENT', embedEnvironment);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
